import React, { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from '../../context/TranslationContext';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const { login, loading, error, isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // If already authenticated, redirect to admin dashboard
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    await login(username, password);
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-form-container">
        <h1>{t('admin.login.title')}</h1>
        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && <div className="error-message">{t('admin.login.invalidCredentials')}</div>}
          
          <div className="form-group">
            <label htmlFor="username">{t('admin.login.username')}</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="form-control"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">{t('admin.login.password')}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-control"
            />
          </div>
          
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? t('admin.login.loggingIn') : t('admin.login.loginButton')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
